import React, { useEffect, useState } from 'react';
import { useOnResume } from '../../hooks/on-resume';
import { BrowseFeedItem } from '../../components/browse/feed/item/BrowseFeedItem';
import { useBrowseFeed } from '../../hooks/browse-feed';
import { useToggle } from '../../hooks/toggle';
import styled from 'styled-components';
import { XInput } from '../../components/x/input/XInput';
import { BrowseGeolocation } from '../../components/browse/geolocation/BrowseGeolocation';
import { useGeolocation } from '../../hooks/geolocation';
import { stringIncludes } from '../../util/stringIncludes';
import { XSButton } from '../../xs/component/button/XSButton';
import { XSSection } from '../../xs/component/section/XSSection';

export function BrowsePage() {
    useGeolocation().useRegister();

    const { loadFeed, feedNearby, feedAway } = useBrowseFeed();
    const [searchKeyword, setSearchKeyword] = useState('');
    const [isFeedAwayVisible, toggleIsFeedAwayVisible] = useToggle();

    useEffect(() => {
        loadFeed();
    }, [loadFeed]);

    useOnResume(loadFeed, [loadFeed]);

    function mapFeed(feed) {
        return feed
            .filter((item) => {
                if (item.name) {
                    return stringIncludes(item.name, searchKeyword);
                }

                return true;
            })
            .map((item) => <BrowseFeedItem item={item} key={item.id} />);
    }

    return (
        <>
            <DivHeader>
                <XInput
                    value={searchKeyword}
                    onChangeValue={setSearchKeyword}
                    iconStart="search"
                    placeholder="Search"
                    clearable
                />
            </DivHeader>

            <BrowseGeolocation />

            {(searchKeyword || '').length > 0 ? (
                <DivGrid>{mapFeed([...feedNearby, ...feedAway])}</DivGrid>
            ) : (
                <>
                    {feedNearby.length > 0 && <DivGrid>{mapFeed(feedNearby)}</DivGrid>}

                    {feedAway.length > 0 && !isFeedAwayVisible && (
                        <XSSection>
                            <XSButton onClick={toggleIsFeedAwayVisible} block>
                                Show places further away
                            </XSButton>
                        </XSSection>
                    )}

                    {isFeedAwayVisible && (
                        <>
                            <XSSection title={'Further away'} />

                            <DivGrid>{mapFeed(feedAway)}</DivGrid>
                        </>
                    )}
                </>
            )}
        </>
    );
}

const DivHeader = styled.header`
    background-color: var(--x-color-body);
    top: 0;
    position: sticky;
    z-index: 1;
    padding: calc(2 * var(--ui-spacing));
    padding-bottom: var(--ui-spacing);
`;

const DivGrid = styled(XSSection)`
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
`;

BrowsePage.route = '/browse';
